module.exports = __webpack_public_path__ + "img/veri.adc8c90b.svg";